import { Injectable } from '@angular/core'
@Injectable({
  providedIn: 'root'
})

export class FuseqDBDataService {
  getDataTypeFromSqlType (SqlDataType: string) {
    if (SqlDataType) {
      if (SqlDataType.toUpperCase().includes('VARCHAR')) {
        return 'text'
      } else if (SqlDataType.toUpperCase().includes('int4range')) {
        return 'int4range'
      } else if (SqlDataType.toUpperCase().includes('INT') || SqlDataType.toUpperCase().includes('NUMERIC')) {
        return 'number'
      } else if (SqlDataType.toUpperCase().includes('BOOL')) {
        return 'checkbox'
      } else if (SqlDataType.toUpperCase() === 'DATE') {
        return 'date'
      } else if (SqlDataType.toUpperCase() === 'TIME') {
        return 'time'
      } else if (SqlDataType.toUpperCase() === 'JSON') {
        return 'json'
      } else if (SqlDataType.toUpperCase() === 'JSONB') {
        return 'jsonb'
      } else if (SqlDataType.toUpperCase().includes('TIMESTAMP') || SqlDataType.toUpperCase().includes('TIMESTAMPTZ')) {
        return 'timestamp'
      } else if (SqlDataType.toUpperCase().includes('INET')) {
        return 'inet'
      } else if (SqlDataType.toUpperCase().includes('BYTEA')) {
        return 'file'
      } else if (SqlDataType.toUpperCase().includes('MACADDR')) {
        return 'macaddr'
      } else {
        return 'text'
      } // DEFAULT CASE
    }
    return null
  }
}
